const startsWith = require('lodash/startsWith');
const endsWith = require('lodash/endsWith');

let api = {
    validateImageMimeType: (file) => {
        return (
            !!file
            && file.type 
            && startsWith(file.type.toLowerCase(), 'image')
        );
    },

    // file.type is often not present when choosing .csv files
    validateCsvMimeType: (file) => {
        // return type.toLowerCase() === 'text/csv';
        return (
            !!file
            && file.name
            && endsWith(file.name.toLowerCase(), '.csv')
        );
    },

    validateJsonMimeType: (file)=>{
        return (
            !!file
            && file.name
            && endsWith(file.name.toLowerCase(), '.json') // application/json
        );
    },
    
    resolveAssetPath: (assetSource) => {
        //TODO: use globals.asset.STATIC_PREFIX in this regex
        return assetSource.replace(/^\$ASSET_PREFIX/, GlobalConfig.AssetStoreUrl);
    },

    resolveAssetPathEverywhere: (assetSource) => {
        return assetSource.replace(/\$ASSET_PREFIX/g, GlobalConfig.AssetStoreUrl);
    }
};

api.validatorMap = {
    'image': api.validateImageMimeType,
    'csv': api.validateCsvMimeType,
    'json': api.validateJsonMimeType,
};

module.exports = api;
